export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
export const REGISTERED_LOGIN_REQUEST = 'REGISTERED_LOGIN_REQUEST';
export const REGISTERED_LOGIN_SUCCESS = 'REGISTERED_LOGIN_SUCCESS';
export const REGISTERED_LOGIN_FAIL = 'REGISTERED_LOGIN_FAIL';
export const REGISTERED_LOGOUT = 'REGISTERED_LOGOUT';
export const REGISTERED_CLAIM_REQUEST = 'REGISTERED_CLAIM_REQUEST';
export const REGISTERED_CLAIM_SUCCESS = 'REGISTERED_CLAIM_SUCCESS';
export const REGISTERED_CLAIM_FAIL = 'REGISTERED_CLAIM_FAIL';
export const REGISTERED_CLAIM_ACKNOWLEDGED = 'REGISTERED_CLAIM_ACKNOWLEDGED';
export const REGISTERED_GET_CLAIMED_REQUEST = 'REGISTERED_GET_CLAIMED_REQUEST';
export const REGISTERED_GET_CLAIMED_SUCCESS = 'REGISTERED_GET_CLAIMED_SUCCESS';
export const REGISTERED_GET_CLAIMED_FAIL = 'REGISTERED_GET_CLAIMED_FAIL';
export const REGISTERED_GET_CLAIMED_LEGACY_REQUEST = 'REGISTERED_GET_CLAIMED_LEGACY_REQUEST';
export const REGISTERED_GET_CLAIMED_LEGACY_SUCCESS = 'REGISTERED_GET_CLAIMED_LEGACY_SUCCESS';
export const REGISTERED_GET_CLAIMED_LEGACY_FAIL = 'REGISTERED_GET_CLAIMED_LEGACY_FAIL';
export const REGISTERED_CURRENT_OFFERS_REQUEST = 'REGISTERED_CURRENT_OFFERS_REQUEST';
export const REGISTERED_CURRENT_OFFERS_SUCCESS = 'REGISTERED_CURRENT_OFFERS_SUCCESS';
export const REGISTERED_CURRENT_OFFERS_FAIL = 'REGISTERED_CURRENT_OFFERS_FAIL';
export const REGISTERED_GET_DASHBOARD_REQUEST = 'REGISTERED_GET_DASHBOARD_REQUEST';
export const REGISTERED_GET_DASHBOARD_SUCCESS = 'REGISTERED_GET_DASHBOARD_SUCCESS';
export const REGISTERED_GET_DASHBOARD_FAIL = 'REGISTERED_GET_DASHBOARD_FAIL';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_EXECUTE_REQUEST = 'RESET_PASSWORD_EXECUTE_REQUEST';
export const RESET_PASSWORD_EXECUTE_SUCCESS = 'RESET_PASSWORD_EXECUTE_SUCCESS';
export const RESET_PASSWORD_EXECUTE_FAIL = 'RESET_PASSWORD_EXECUTE_FAIL';
